<script>
  export let EDITABLE = false;
</script>

<div class="th  border-b border-gray-100 font-semibold text-gray-600">
  {#if EDITABLE}
    <h1 style="min-width: 10rem; max-width: 10rem;">Actions</h1>
  {/if}
  <div style="min-width: 15rem; max-width: 15rem;">Material Name</div>
  <div style="min-width: 7rem; max-width: 7rem;">Plank Number</div>
  <div style="min-width: 7rem; max-width: 7rem;">Needed</div>

  {#if EDITABLE}
    <div style="min-width: 7rem; max-width: 7rem;" class="text-red-400">
      In Stock
    </div>
    <div style="min-width: 7rem; max-width: 7rem;">Used</div>
    <div style="min-width: 7rem; max-width: 7rem;">To be ordered</div>
  {/if}

  <div style="min-width: 7rem; max-width: 7rem;">Unit Price</div>
  <div style="min-width: 7rem; max-width: 7rem;">Total Price</div>
</div>

<style>
  .th {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 20px;
  }
</style>
